import { MuiStyles } from "@osu/react-ui";
import { useMemo } from "react";

function useTableStyles() {
  const theme = MuiStyles.useTheme();
  
  const sharedTableStyles = useMemo(() => {
    return theme.palette.mode === "dark"
      ? {
          backgroundColor: "#333",
          color: "#f5f5f5",
          "& tr.MuiTableRow-root": {
              backgroundColor: "#333 !important",
              color: "#f5f5f5",
          },
          "& th.MuiTableHead-root": {
              backgroundColor: "#333 !important",
              color: "#f5f5f5",
          },
          "& .MuiFormLabel-root": {
              color: "#f5f5f5",
          },
          "& .MuiInputBase-root": {
              color: "#f5f5f5",
          },
          "& .MuiSvgIcon-root": {
              color: "#f5f5f5 !important",
          },
          "& .MuiFormHelperText-root": {
              color: "#f5f5f5 !important",
          },
          "& .MuiButtonBase-root": {
              color: "#f5f5f5 !important",
          },
          "& .MuiBadge-root": {
              color: "#f5f5f5 !important",
          },
          "& .MuiDivider-root": {
              borderColor: "#c1c5c9 !important",
          },
          "& .MuiAlert-message": {
              backgroundColor: "#333",
              color: "#f5f5f5 !important",
          },
          "& .MuiPaper-root": {
              backgroundColor: "#1c1c1c",
              color: "#f5f5f5 !important",
          },
          '& td[data-pinned="true"]:before': {
              backgroundColor: "#333",
              color: "#f5f5f5 !important",
          },
          '& th[data-pinned="true"]:before': {
              backgroundColor: "#333",
              color: "#f5f5f5 !important",
          },
      }
      : {};
  }, [theme.palette.mode]);

  return { sharedTableStyles };
}

export default useTableStyles;